/**
 * Use this file for JavaScript code that you want to run in the front-end
 * on posts/pages that contain this block.
 *
 * When this file is defined as the value of the `viewScript` property
 * in `block.json` it will be enqueued on the front end of the site.
 *
 * Example:
 *
 * ```js
 * {
 *   "viewScript": "file:./view.js"
 * }
 * ```
 *
 * If you're not making any changes to this file because your project doesn't need any
 * JavaScript running in the front-end, then you should delete this file and remove
 * the `viewScript` property from `block.json`.
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/block-api/block-metadata/#view-script
 */

/* eslint-disable no-console */
window.addEventListener("load", async () => {
  const response = await fetch(
    `${gvvAjax.ajax_url}?action=get_first_future_match`,
  );
  if (response.status !== 200) {
    console.error("Error fetching upcoming match:", response.statusText);
    return;
  }
  const { data: cMatch } = await response.json();
  document.querySelectorAll(".coming-match-hometeam-logo").forEach((el) => {
    el.style.backgroundImage = `url(${cMatch.home_team_logo})`;
  });
  document.querySelectorAll(".coming-match-awayteam-logo").forEach((el) => {
    el.style.backgroundImage = `url(${cMatch.away_team_logo})`;
  });
  document
    .querySelectorAll(".wp-block-gvv-upcoming-match__left__team")
    .forEach((el) => {
      el.innerText = cMatch.home_team_name;
    });
  document
    .querySelectorAll(".wp-block-gvv-upcoming-match__right__team")
    .forEach((el) => {
      el.innerText = cMatch.away_team_name;
    });
  document
    .querySelectorAll(".wp-block-gvv-upcoming-match__team")
    .forEach((el) => {
      el.innerText = `${cMatch.home_team_name} - ${cMatch.away_team_name}`;
    });
  document
    .querySelectorAll(".wp-block-gvv-upcoming-match__center__date")
    .forEach((el) => {
      el.innerText = new Date(cMatch.start_date).toLocaleString("nl-NL", {
        dateStyle: "full",
        timeStyle: "short",
      });
    });
  document
    .querySelectorAll(".wp-block-gvv-upcoming-match__center__location")
    .forEach((el) => {
      el.innerText = `${cMatch.accommodation} in ${cMatch.city}`;
    });
  document
    .querySelectorAll(".wp-block-gvv-upcoming-match__center__field")
    .forEach((el) => {
      el.innerText = cMatch.field;
    });
}); /* eslint-enable no-console */
